import _ from 'lodash'
import Organization from './organization'
import config from 'scoreboard/components/config'
import treeSomeAncestors from 'scoreboard/components/tree-some-ancestors'

function movable (orgTreeItem) {
	let org = new Organization(orgTreeItem)

	if (org.isTreeCopy() && org.get('templateId') != org.get('templateRootId')) {
		// Can't move a tree copy unless it's the root (templateId == templateRoootId)
		return false
	}

	if (org.isDatasetCopy()) {
		return false;
	}

	if (!_.isNil(org.get('syncId'))) {
		return false
	}

	let parentTreeItem = this.parent(orgTreeItem)
	if (parentTreeItem != null) {
		let parent = new Organization(parentTreeItem)
		// Can't move a dataset template's "archive" container organization
		if (parent.isDatasetTemplate() && parent.get('archiveOrganizationId') == org.id) {
			return false
		}
	}

	return true
}

function droppable (moving, parent) {
	if (!moving.cascade || !parent.cascade || !_.isNil(moving.syncId) || !_.isNil(parent.syncId)) {
		return false
	}

	//#21478 prevent dropping unreplicated onto trees where replication is cascaded on the low side
	if (config.replicationOutputEnabled && (!moving.replicated || moving.unreplicatedChildren)) {
		if (parent.replicatedCascaded || treeSomeAncestors(this, parent.id, parent => parent.replicatedCascaded)) {
			return false
		}
	}

	if (moving.templateId) {
		// Can't move a copy under a template tree. Look at the target parent
		// and all its ancestors to make sure we don't run into part of a tree template
		var currentParent = parent
		while (!_.isNil(currentParent)) {
			if (currentParent.rootTemplateRootId) {
				return false
			}

			currentParent = this.parent(currentParent.id)
		}
	}

	if (moving.rootTemplateRootId == moving.id) {
		// Can't move the root of a tree template under another tree template.
		// You can, however, move children of a tree template withing that template
		// or BETWEEN two different tree templates
		var currentParent = parent
		while (!_.isNil(currentParent)) {
			if (currentParent.rootTemplateRootId) {
				return false
			}

			currentParent = this.parent(currentParent.id)
		}
	}

	return true
}

export { movable }
export { droppable }
